import { render } from "./Repair.vue?vue&type=template&id=1ae6f75b"
import script from "./Repair.vue?vue&type=script&lang=js"
export * from "./Repair.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/ravanjeyhan-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__